import React from 'react';
import OuterContainer from '../PatientSummary/OuterContainer';
import { ROPatientContextProvider } from '../PatientSummary/context';
import ScribeContainer from './ScribeContainer';

const ScribePage = (): JSX.Element => {
  return (
    <ROPatientContextProvider>
      <OuterContainer marginBottom="0px" rowSpace="0px">
        <ScribeContainer />
      </OuterContainer>
    </ROPatientContextProvider>
  );
};

export default ScribePage;
